import { SkeletonBar } from "../../../components/Skeleton/Skeleton";
// @ts-ignore
import "./ExpensesDetails.css";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

/* Page-shaped loading skeleton for /expenses-detail. Used BOTH as the route's
   Suspense fallback (while the chunk loads) and as the screen's own loading
   state, so the two are identical and the page never flashes a different
   skeleton in between. */
const ExpensesDetailsSkeleton = () => (
  <div className="page-content-wraper exp-page">
    {/* ---------- top bar ---------- */}
    <div className="exp-topbar">
      <div className="exp-crumb">
        <h1>Detailed Budget</h1>
        <p>Expenses · Annual budget by category</p>
      </div>
      <div className="exp-actions">
        <SkeletonBar w={132} h={40} r={9} />
      </div>
    </div>

    {/* ---------- table ---------- */}
    <div className="exp-card">
      <div className="exp-table-wrap">
        <table className="exp-table">
          <thead>
            <tr>
              <th className="exp-head">Heads</th>
              <th className="exp-act">Action</th>
              {MONTHS.map((m) => (
                <th key={m}>{m}</th>
              ))}
              <th className="exp-total-col">Total</th>
              <th> </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 }).map((_, i) => (
              <tr key={`skl-${i}`}>
                <td className="exp-item-name">
                  <SkeletonBar w={`${52 + (i % 4) * 12}%`} h={11} />
                </td>
                <td className="exp-act">
                  <SkeletonBar w={18} h={18} r={5} style={{ margin: "0 auto" }} />
                </td>
                {MONTHS.map((m, j) => (
                  <td key={m}>
                    <SkeletonBar w={`${58 + ((i + j) % 4) * 10}%`} h={11} />
                  </td>
                ))}
                <td>
                  <SkeletonBar w={`${60 + (i % 3) * 12}%`} h={11} />
                </td>
                <td></td>
              </tr>
            ))}
          </tbody>

          <tbody className="exp-totals">
            <tr>
              <td className="exp-total-label">
                <SkeletonBar w={96} h={11} />
              </td>
              <td></td>
              {MONTHS.map((m) => (
                <td key={m}>
                  <SkeletonBar w="64%" h={11} />
                </td>
              ))}
              <td>
                <SkeletonBar w="70%" h={11} />
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    {/* ---------- action bar (Save) ---------- */}
    <div className="exp-actionbar">
      <div className="exp-actionbar-inner">
        <SkeletonBar w={92} h={40} r={9} />
      </div>
    </div>
  </div>
);

export default ExpensesDetailsSkeleton;
